/** Mapeo fila API assignments.php → ítem de tabla en AssignmentModule. */
export function mapAssignmentApiRow(a) {
  const qty = Number(a.quantity) || 0;
  const assigneeType = String(a.assignee_type || '').toLowerCase() === 'vehicle' || Number(a.vehicle_id || 0) > 0
    ? 'vehicle'
    : 'person';
  const plate = String(a.vehicle_plate || '').trim();
  const vehicleId = Number(a.vehicle_id || 0) || null;
  const responsibleName = assigneeType === 'vehicle'
    ? (plate ? `Vehículo ${plate}` : (vehicleId ? `Vehículo #${vehicleId}` : 'Vehículo'))
    : (a.person_name || String(a.person_dni || a.person_id || ''));
  const responsibleDoc = assigneeType === 'vehicle'
    ? (vehicleId ? `vehicle:${vehicleId}` : null)
    : (a.person_dni || a.person_id);
  return {
    id: a.id,
    assignmentDbId: a.id,
    materialId: a.material_id,
    materialName: a.material_name || '',
    materialCode: a.material_code || '',
    assigneeType,
    vehicleId,
    vehiclePlate: plate,
    responsibleDoc,
    responsibleName,
    quantity: qty,
    assignDate: a.created_at ? String(a.created_at).slice(0, 10) : '',
    serial: String(a.serial || '').trim(),
    brandName: String(a.brand || '').trim(),
    status: qty <= 0 ? 'Devuelto' : 'Asignado',
    evidencePhotos: [],
    warehouseId: a.warehouse_id || '',
  };
}
